import React, { useEffect, useState } from 'react';
import {Col, Row, Card, CardBody, Button, Modal, Label, FormGroup} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Breadcrumb from "../../../src/components/Common/Breadcrumb";
import imgdark from "../../assets/images/logo-dark.png";
import Select from "react-select"
import * as url from "../../helpers/url_helper"
import moment from "moment";
const ViewFiche = (props) => {
    // document.title = "Invoice | Lexa - Responsive Bootstrap 5 Admin Dashboard";

    const breadcrumbItems = [
        { title: "Lexa", link: "#" },
        { title: "Pages", link: "#" },
        { title: "Invoice", link: "#" },
    ]
    const location= useLocation();
    const [list, setList]= useState([]);
    const [ficheParam, setFicheParam]= useState();
    const [modal_formfiche, setmodal_formfiche] = useState(false)
    const [selectDemande, setSelectDemande] = useState(null);
    const [demandes, setDemandes] = useState([]);
    const [demande, setDemande] = useState(null);
    const optionDemande = [ { options: demandes } ]
    const [msgError, setMsgError]= useState("");
    const [msgSuccess, setMsgSuccess]= useState("");
    const [startDate, setStartDate]= useState(moment().subtract(15, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate]= useState(moment().format('YYYY-MM-DD'));
    useEffect(() => { 
        if (location.state?.fiche) { setFicheParam(location.state.fiche); }
        props.setBreadcrumbItems('Invoices', breadcrumbItems) 
    }, [props])

    useEffect(()=>{ if (ficheParam?.id) { loadFiches() } loadDemandes() }, [ficheParam])
    const handleDemande= (event)=>{ setSelectDemande(event); setDemande(event.value); }
    function removeBodyCss() { document.body.classList.add("no_padding") }
    function tog_formfiche() { setmodal_formfiche(!modal_formfiche); removeBodyCss() }

    const verifData= ()=>{
        if (demande==="" || demande==='undefined' || demande==null) { setMsgError("Sélectionner une demande svp"); return false;}
        else {return true; }
      }

    const loadFiches=()=> {
        fetch(url.API_LIVRAISON_BACKEND+"/fiches-item?fiche="+ficheParam.id+"&size=100", {
          method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
        .then((response) => response.json())
        .then((responseJson) => { 
          if (responseJson.status==200) { 
            setList(responseJson.data.items);
        } else { setList([]); }
        }) .catch((error) => { });
    };

    const addDemande=()=>{
        if (verifData()) {
            fetch(url.API_LIVRAISON_BACKEND+"/fiches-item", {
            method: 'POST', headers: {'Content-Type': 'application/json', 'accept': 'application/json'},
            body: JSON.stringify( { fiche: {id: ficheParam.id}, demande: {id: demande} }) })
            .then((response) => response.json())
            .then((responseJson) => { console.log(responseJson.data);
            if (responseJson.status==200) { 
                loadFiches();
                setMsgSuccess(responseJson.message)
            } else { setMsgError(responseJson.message);  }
            }) .catch((error) => { setMsgError(error.message); });
        }
    }
    
    const loadDemandes=()=> {
        let demandeArray=[];
        fetch(url.API_LIVRAISON_BACKEND+"/demandes?start="+startDate+"&end="+endDate+"&page=0&size=200&stat=1", {
          method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
        .then((response) => response.json())
        .then((responseJson) => { console.log(responseJson.data);
          if (responseJson.status==200) { 
            demandeArray=[
                ...demandeArray,
                ...responseJson.data.items.map(item=>({
                    label: "Colis Numero "+item?.operation?.code+" ("+item?.operation?.detail[0]?.embal?.libelle+", "+item?.operation?.detail[0]?.nature?.libelle+") à livrer à "+item.zone.commune.nom+" "+item.zone.nom+" "+item.adress,
                    value: item.id
                }))
            ]
            setDemandes(demandeArray)
        } else { setDemandes([])  }
        }) .catch((error) => {  setDemandes([]) });
      };
    const AddDemande= ()=>{
        alert("Add demande");
    }
    //Print the Invoice
    const printInvoice = () => {
        window.print();
    }

    return (
        <React.Fragment>
            <Breadcrumb onAddDemande={tog_formfiche} />
            <Modal
                size="xl"
                isOpen={modal_formfiche}
                toggle={() => { tog_formfiche() }}
                >
                <div className="modal-header">
                <h5 className="modal-title mt-0" id="myLargeModalLabel">Formulaire de création de fiche de livraison</h5>
                <button
                    onClick={() => {
                    setmodal_formfiche(false)
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true" style={{ color: "black" }}>x</span>
                </button>
                <Col xl="3">
                    <Button className="btn btn-lg btn-primary" tag="button" onClick={()=>{addDemande()}}>
                        Ajouter la demande
                    </Button>
                </Col>
                </div>
                <div className="modal-body">
                <Row>
                    <Col xl="12">
                    <FormGroup className="mb-4">
                        <div className="mb-3">
                        <Label>Demandes</Label>
                        <Select
                            value={selectDemande}
                            onChange={handleDemande}
                            options={optionDemande}
                            classNamePrefix="select2-selection"
                        />
                        </div>
                    </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xl="6">
                    <strong style={{ fontSize: 16, color:"rgb(236, 83, 108)"}}>{msgError}</strong>
                    <strong style={{ fontSize: 16, color: "#02a499" }}>{msgSuccess}</strong>
                    </Col>
                </Row>
                </div>
            </Modal>
            <Row>
                <Col xs="12">
                    <Card>
                        <CardBody>

                            <Row>
                                <Col xs="12">
                                    <div className="invoice-title">
                                        <h4 className="float-end font-size-16"><strong>Fiche # {ficheParam?.id}</strong></h4>
                                        <h3>
                                            <img src={imgdark} alt="logo" height="24" />
                                        </h3>
                                    </div>
                                    <hr />
                                    <Row>
                                        <Col xs="6">
                                            <address>
                                                <strong>Livreur:</strong><br />
                                                            {ficheParam?.livreur?.nom}<br />
                                                            {ficheParam?.livreur?.phone}
                                                        </address>
                                        </Col>
                                        <Col xs="6" className="text-end">
                                            <address>
                                                <strong>Entreprise partenaire:</strong><br />
                                                {ficheParam?.livreur?.partenaire?.nom}<br />
                                                {ficheParam?.livreur?.partenaire?.phone}
                                            </address>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="6" >
                                            
                                        </Col>
                                        <Col xs="6" className="text-end">
                                            <address>
                                                <strong>Date édition:</strong><br />{moment(ficheParam?.create).format("DD-MM-YYYY")}<br/>
                                            </address>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs="12">
                                    <div>
                                        <div className="p-2">
                                            <h3 className="font-size-16"><strong>Liste des demandes</strong></h3>
                                        </div>
                                        <div className="">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <td><strong>Infos colis</strong></td>
                                                            <td><strong>Info client</strong></td>
                                                            <td><strong>Montant</strong></td>
                                                            <td className="text-end"><strong>Status</strong></td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list.map((item, key)=>(
                                                            <tr>
                                                                <td>{item?.demande?.operation?.code},{" "}
                                                                    {item?.demande?.operation?.detail[0]?.embal?.libelle}, {" "}
                                                                    {item?.demande?.operation?.detail[0]?.nature?.libelle} <br/>
                                                                    {item?.demande?.operation?.agexp?.ville} - {item?.demande?.operation?.agdest?.ville}
                                                                </td>
                                                                <td>
                                                                {item?.demande?.clt?.nom} ({item?.demande?.clt?.phone}, {item?.demande?.phone})<br/>
                                                                {item?.demande?.zone?.commune?.nom}, {item?.demande?.zone?.nom}, 
                                                                {item?.demande?.adress}
                                                                </td>
                                                                <td>{item?.demande?.zone?.tarif} FCFA</td>
                                                                <td className="text-end"></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="d-print-none">
                                                <div className="float-end">
                                                    <Link to="#" onClick={printInvoice} className="btn btn-success waves-effect waves-light me-2">Imprimer <i className="fa fa-print"></i></Link>{" "}
                                                    {/* <Link to="#" className="btn btn-primary waves-effect waves-light">Send</Link> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default connect(null, { setBreadcrumbItems })(ViewFiche);